import { useAryLazyQuery } from 'framework/base/hooks/useAryGraphql';
import { useEffect, useState } from 'react';

const useAryCalculationState = ({ gqlConfig, selectedId, forceCalculate }) => {
  const [trigger, setTrigger] = useState(false);
  const [isCalculateDone, setIsCalculateDone] = useState(false);
  const [getCalculateState, { data: getCalculateStateData, loading }] =
    useAryLazyQuery({
      gqlConfig,
      items: `
        isDone
    `
    });

  useEffect(() => {
    if (selectedId !== '' && selectedId !== undefined) {
      getCalculateState(selectedId);
      if (getCalculateStateData !== undefined) {
        setIsCalculateDone(getCalculateStateData?.isDone);
      }
      if (!getCalculateStateData?.isDone) {
        setTimeout(() => {
          setTrigger(!trigger);
          if (!loading) {
            getCalculateState(selectedId);
          }
        }, 1000);
      }
    }
  }, [getCalculateStateData?.isDone, trigger, selectedId, forceCalculate]);

  return [isCalculateDone];
};

export default useAryCalculationState;
